import React, { useState } from "react";
import { Languages, Moon, Sun, Menu, X } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function Header() {
  const { lang, setLang, theme, setTheme, t } = useApp();
  const [open, setOpen] = useState(false);

  const navItems = [
    { key: "home", href: "#inicio", label: t.nav.home },
    { key: "services", href: "#servicios", label: t.nav.services },
    { key: "academy", href: "#academia", label: t.nav.academy },
    { key: "diy", href: "#fainoti", label: t.nav.diy },
    { key: "contact", href: "#contacto", label: t.nav.contact },
  ];

  return (
    <header
      data-testid="site-header"
      className="ht-glass sticky top-0 z-40 w-full border-b"
      style={{ borderColor: "var(--ht-border)" }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        {/* Logo */}
        <a
          href="#inicio"
          data-testid="logo-link"
          className="flex items-center gap-3"
          onClick={() => setOpen(false)}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_homeatope-academy/artifacts/0u9eykli_Logotipo%20Homeatope%20volando.jpg"
            alt="Home a tope - Fontanería y Electricidad"
            className="h-11 w-11 rounded-lg object-contain sm:h-12 sm:w-12"
            style={{ background: "#fff" }}
            data-testid="logo-img"
          />
          <span className="ht-wordmark hidden sm:inline-flex" translate="no">
            <span className="ht-wordmark-home text-[22px]" translate="no">HOME</span>
            <span className="ht-wordmark-atope text-[20px]" translate="no">a tope</span>
            <span
              className="mt-1 text-[9px] font-semibold uppercase tracking-[0.22em]"
              style={{ color: "var(--ht-text-muted)" }}
            >
              Fontanería · Electricidad
            </span>
          </span>
          <span className="ht-wordmark inline-flex sm:hidden" translate="no">
            <span className="ht-wordmark-home text-lg" translate="no">HOME</span>
            <span className="ht-wordmark-atope text-base" translate="no">a tope</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-7 md:flex">
          {navItems.map((n) => (
            <a
              key={n.key}
              href={n.href}
              data-testid={`nav-${n.key}`}
              className="text-sm font-medium transition-colors hover:opacity-70"
              style={{ color: "var(--ht-text)" }}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {/* Lang toggle */}
          <button
            type="button"
            data-testid="lang-toggle"
            onClick={() => setLang(lang === "es" ? "gl" : "es")}
            className="ht-card flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold uppercase tracking-wider"
            title="Idioma"
          >
            <Languages size={14} />
            {lang.toUpperCase()}
          </button>

          {/* Theme toggle */}
          <button
            type="button"
            data-testid="theme-toggle"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="ht-card flex h-9 w-9 items-center justify-center"
            title={theme === "dark" ? t.theme.light : t.theme.dark}
          >
            {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
          </button>

          {/* Mobile menu */}
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="ht-card flex h-9 w-9 items-center justify-center md:hidden"
            aria-label="menu"
          >
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <nav
          data-testid="mobile-nav"
          className="border-t md:hidden"
          style={{ borderColor: "var(--ht-border)" }}
        >
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {navItems.map((n) => (
              <a
                key={n.key}
                href={n.href}
                data-testid={`mobile-nav-${n.key}`}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm font-medium"
                style={{ color: "var(--ht-text)" }}
              >
                {n.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
